import PropTypes from 'prop-types';
import React from 'react';

import TenantInstitutionTypes from '../../../../model/TenantInstitutionTypes';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';

const TenantInstitutionTypeSelector = props => {
  const t = useT();

  const { options } = useEnumerableModel(TenantInstitutionTypes);

  return (
    <MultiselectFilter
      itemId={itemIdValue}
      options={options}
      title={t('Institution type')}
      {...props}
    />
  );
};

TenantInstitutionTypeSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOf(TenantInstitutionTypes.BasicValues)),
  onChange: PropTypes.func,
};

TenantInstitutionTypeSelector.defaultProps = {
  value: null,
  onChange: null,
};

export default TenantInstitutionTypeSelector;
